import React from 'react';
import { HEX_COLOR } from "./format";

interface propsInterface {
  color?: string | null;
  title?: string;
}

// A plan color, or an empty checkered box when the admin left it unset
// and the client falls back to its own palette.
const _Swatch = ({ color, title }: propsInterface) => {
  const valid = HEX_COLOR.test(color || '');

  return (
    <span
      title={title ? `${title}: ${color || 'not set'}` : color || 'not set'}
      style={{
        display: 'inline-block',
        width: 16,
        height: 16,
        verticalAlign: 'middle',
        borderRadius: 3,
        border: '1px solid rgba(0, 0, 0, 0.15)',
        background: valid
          ? (color as string)
          : 'repeating-linear-gradient(45deg, #f0f0f0 0 4px, #fafafa 4px 8px)'
      }}
    />
  )
}

export default _Swatch;
